// Product.js

import React, { Component } from 'react';
import { Button, Form, Container, Row, Col, ButtonToolbar, Overlay, Popover } from 'react-bootstrap';
import Config from '../Config';
import ScrollArea from 'react-scrollbar';
import Modal from 'react-awesome-modal';
import ProductDetail from './ProductDetail';
import ProductTitle from './ProductTitle';
import ProductPhoto from './ProductPhoto';
import ProductQRList from './ProductQRList';
import DRMExplanation from './DRMExplanation';
import ProductImageMap from './ProductImageMap';

import AutoSizer from 'react-virtualized/dist/commonjs/AutoSizer';
import Column from 'react-virtualized/dist/commonjs/Table/Column';
import Table from 'react-virtualized/dist/commonjs/Table';
import SortDirection from 'react-virtualized/dist/commonjs/Table/SortDirection';
import SortIndicator from 'react-virtualized/dist/commonjs/Table/SortIndicator';
import styles from './Table.css';

const productPrice = '{\
    "web.0y.reg": { "원": 31000, "$": 24.99 },\
    "web.1y.reg": { "원": 25000, "$": 19.99 },\
    "web.1m.reg": { "원": 12000, "$": 9.99 },\
    "web.1w.reg": { "원": 1200, "$": 0.99 }\
}';
const ProductLocals = ["Eng", "Kor", "Jpn", "Chn", "Esp", "Fra"];
const ProductDefaults = {
    PCODE: '0000', USE_FLAG: '0', REVIEW_FLAG: '1', PIMAGE: ''
    , SUBLANGS: ProductLocals, PLAYTIME: 0, PREVIEW: '', FILESIZE: 0, QUALITY: 'HD', AGELIMIT: 12, FAVORITES: 0
    , FREE_FLAG: 0, PRICE: productPrice, BUY_URL: ''
};

class RowItem extends Component {
    static defaultProps = {
        item: null,
        enable: false,
        onPress: () => { },
    }
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    handleRowClick = (event) => {
        this.props.onPress(this.props.item);
        event.preventDefault();
    }
    render() {
        return (
            <tr onClick={this.handleRowClick}>
                <td>{this.props.item.PCODE}</td>
                <td>{this.props.item.USE_FLAG}</td>
                <td>{this.props.item.REVIEW_FLAG}</td>
                <td>{this.props.item.FREE_FLAG}</td>
                <td>{this.props.item.PIMAGE}</td>
                <td>{this.props.item.SUBLANGS}</td>
                <td>{this.props.item.PLAYTIME}</td>
                <td>{this.props.item.PREVIEW}</td>
                <td>{this.props.item.FILESIZE}</td>
                <td>{this.props.item.QUALITY}</td>
                <td>{this.props.item.AGELIMIT}</td>
                <td>{this.props.item.FAVORITES}</td>
                <td>{this.props.item.REGDATE}</td>
            </tr>
        );
    }
};

class Content extends Component {
    static defaultProps = {
        item: null,
        enable: false,
        onPress: () => { },
    }
    constructor(props) {
        super(props);
        this.SUBLANGS = ProductLocals;
        this.state = {
            detailvisible: false,
            titlevisible: false,
            photovisible: false,
            imageMapvisible: false,
            qrlistvisible: false,
            explanationvisible: false,
            item: this.props.item == undefined ? ProductDefaults : this.props.item,
            enable: false,
            images: [],
            vpreview: [],
            video: [],
            CAMERA: '',
            free: ''
        };
        this.S3timer = null;
    }

    componentWillReceiveProps(nextProps) {
        console.log("componentWillReceiveProps: " + JSON.stringify(nextProps));
        this.setState({ item: nextProps.item, enable: nextProps.enable });
        this.refreshGetInfo();
    }

    refreshGetInfo() {
        if (this.S3timer)
            clearTimeout(this.S3timer);
        this.S3timer = setTimeout(() => {
            this.handleGetInfo(null);
        }, 500);
    }

    handleReset(event) {
        this.setState({
            item: { ...ProductDefaults }
            , enable: true
        });

        event.preventDefault();
    }

    handleDetail() {
        this.setState({ detailvisible: true });
    }
    handleTitle() {
        this.setState({ titlevisible: true });
    }
    handlePhoto() {
        this.setState({ photovisible: true });
    }
    handleImageMap() {
        this.setState({ imageMapvisible: true });
    }

    handleQRList() {
        this.setState({ qrlistvisible: true });
    }
    handleExplanation() {
        this.setState({ explanationvisible: true });
    }

    handleCloseDetail() {
        this.setState({ detailvisible: false });
    }

    handleCloseDetail() {
        this.setState({ detailvisible: false });
    }

    handleCloseTitle() {
        this.setState({ titlevisible: false });
    }

    handleClosePhoto() {
        this.setState({ photovisible: false });
    }

    handleCloseImageMap() {
        this.setState({ imageMapvisible: false });
    }

    handleCloseQRList() {
        this.setState({ qrlistvisible: false });
    }

    handleCloseExplanation() {
        this.setState({ explanationvisible: false });
    }


    handleChange(event) {
        var item = this.state.item;
        item.TITLE = event.target.value;
        this.setState({ item: item });
    }

    handleChangePCODE(event) {
        var item = this.state.item;
        item.PCODE = event.target.value;
        this.setState({ item: item });
        this.refreshGetInfo();
    }

    handleGetInfo(event) {
        Config.fetchData('getproductfiles', {
            PCODE: this.state.item.PCODE,
            FOLDER: ''
        }, (result, count) => {
            console.log('getproductimages=', result);
            this.setState({ images: result })
        }, true);
        Config.fetchData('getproductfiles', {
            PCODE: this.state.item.PCODE,
            FOLDER: '/vpreview'
        }, (result, count) => {
            console.log('getproductvpreview=', result);
            this.setState({ vpreview: result })
        }, true);
        Config.fetchData('getproductfiles', {
            PCODE: this.state.item.PCODE,
            FOLDER: '/video'
        }, (result, count) => {
            console.log('getproductvideo=', result);
            const DRMs = result.filter(function (item) { return item.name.indexOf('.MS4') > -1 || item.name.indexOf('.mp4') > -1 });
            this.setState({ video: DRMs })
            const VTTs = result.filter((el) => { return el.name.indexOf('.vtt') > -1 });

            const filtered = this.SUBLANGS.filter((local) => {
                const flt = VTTs.filter((el) => { return el.name.indexOf(local) > -1 });
                return flt.length > 0;
            })

            var item = this.state.item;
            item.SUBLANGS = JSON.stringify(filtered);
            this.setState({ item: item });
        }, true);
    }

    handleChangePIMAGE(event) {
        var item = this.state.item;
        item.PIMAGE = event.target.value;
        this.setState({ item: item });
    }

    handleChangeBIMAGE(event) {
        var item = this.state.item;
        item.BIMAGE = event.target.value;
        this.setState({ item: item });
    }

    handleChangeNIMAGE(event) {
        var item = this.state.item;
        item.NIMAGE = event.target.value;
        this.setState({ item: item });
    }
    handleChangeLOCALS(event) {
        var item = this.state.item;
        item.SUBLANGS = event.target.value;
        this.setState({ item: item });
    }
    handleChangePLAYTIME(event) {
        var item = this.state.item;
        item.PLAYTIME = event.target.value;
        this.setState({ item: item });
    }
    handleChangePREVIEW(event) {
        var item = this.state.item;
        item.PREVIEW = event.target.value;
        this.setState({ item: item });
    }
    handleChangeDRM(event) {
        console.log('DRMselect:', event.target.value);

        var item = this.state.item;
        var itemDRM = this.state.item.DRM;

        if (event.target.value) {
            if (event.target.value == 'all') {
                item.DRM = ''
                var allSelect = '';
                for (var i = 0; i < this.state.video.length; ++i) {
                    var videoName = this.state.video[i].name;

                    allSelect = allSelect.concat(i == 0 ? "" : ",", videoName);
                }
                console.log('allSelect', allSelect);
                item.DRM = allSelect;
            } else {
                if (itemDRM.indexOf(event.target.value) == -1) {
                    item.DRM = itemDRM + (itemDRM.length > 0 ? "," : "") + event.target.value;
                }
            }
        }

        this.state.video.map((el, index) => {
            if (el.name.trim() == event.target.value.trim()) {
                item.FILESIZE = parseInt(el.size / 1000000);
            }
        })
        this.setState({ item: item });
    }
    handleChangeDRMClick(event) {
        console.log('handleChangeDRMClick:', event.target.value)

    }
    handleChangeDRMValue(event) {
        console.log('DRM', event.target.value)
        var item = this.state.item;
        item.DRM = event.target.value;
        this.setState({ item: item });
    }
    handleChangeFILESIZE(event) {
        var item = this.state.item;
        item.FILESIZE = event.target.value;
        this.setState({ item: item });
    }
    handleChangeQUALITY(event) {
        var item = this.state.item;
        item.QUALITY = event.target.value;
        this.setState({ item: item });
    }
    handleChangeAGELIMIT(event) {
        var item = this.state.item;
        item.AGELIMIT = event.target.value;
        this.setState({ item: item });
    }
    handleChangeFAVORITES(event) {
        var item = this.state.item;
        item.FAVORITES = event.target.value;
        this.setState({ item: item });
    }
    handleChangeVideoWidth(event) {
        var item = this.state.item;
        item.VIDEOWIDTH = event.target.value;
        this.setState({ item: item });
    }
    handleChangeFullScreen(event) {
        var item = this.state.item;
        item.FULLSCREEN = event.target.value;
        this.setState({ item: item });
    }
    handleChangeUSE(event) {
        var item = this.state.item;
        item.USE_FLAG = event.target.value;
        this.setState({ item: item });
    }

    handleChangeREVIEW(event) {
        var item = this.state.item;
        item.REVIEW_FLAG = event.target.value;
        this.setState({ item: item });
    }

    handleChangeCountry(event) {
        this.setState({ country: event.target.value });
    }

    handleChangePrice(event) {
        var item = this.state.item;
        item.PRICE = event.target.value;
        this.setState({ item: item });
    }


    handleSubmit(event) {

        var result = confirm("저장 하시겠습니까?");
        if (result) {
            try {
                var price = JSON.parse(this.state.item.PRICE);

                Config.fetchData('insproduct', {
                    PCODE: this.state.item.PCODE,
                    USE_FLAG: parseInt(this.state.item.USE_FLAG),
                    FREE_FLAG: parseInt(this.state.item.FREE_FLAG),
                    REVIEW_FLAG: parseInt(this.state.item.REVIEW_FLAG),
                    PIMAGE: this.state.item.PIMAGE,
                    SUBLANGS: this.state.item.SUBLANGS,
                    PLAYTIME: this.state.item.PLAYTIME,
                    PREVIEW: this.state.item.PREVIEW,
                    FILESIZE: this.state.item.FILESIZE,
                    QUALITY: this.state.item.QUALITY,
                    AGELIMIT: this.state.item.AGELIMIT,
                    FAVORITES: this.state.item.FAVORITES,
                    PRICE: this.state.item.PRICE,
                    BUY_URL: this.state.item.BUY_URL,
                }, (result, count) => {
                    console.log('insproduct=', count);
                    this.setState({ sendcount: count })
                }, true);
            } catch (e) {
                alert(e);
            }
        }
        event.preventDefault();
    }

    handleRemove(event) {

        Config.fetchData('delproduct', {
            ID: this.state.item.ID,
            COUNTRY_CODE: this.state.item.COUNTRY_CODE,
            LANGUAGE_CODE: this.state.item.LANGUAGE_CODE
        }, (result, count) => {
            console.log('delproduct=', count);
            this.setState({ sendcount: count })

        }, true);

        event.preventDefault();
    }

    cameraType(event) {
        var item = this.state.item;
        item.VR_FLAG = event.target.value;
        this.setState({ item: item });
    }

    imageMapUse(event) {
        var item = this.state.item;
        item.IMAP_FLAG = event.target.value;
        this.setState({ item: item });
    }

    freeContent(event) {
        var item = this.state.item;
        item.FREE_FLAG = event.target.value;
        this.setState({ item: item });
    }

    buyURL(event) {
        var item = this.state.item;
        item.BUY_URL = event.target.value;
        this.setState({ item: item });
    }

    render() {
        return (
            <div className="box" >
                <div className="row" style={{ margin: 20 }}>
                    <Button variant="primary" onClick={this.handleSubmit.bind(this)}>저장</Button>
                    <Button variant="primary" onClick={this.handleDetail.bind(this)}>상세정보</Button>
                    <Button variant="primary" onClick={this.handleTitle.bind(this)}>타이틀정보</Button>
                    <Button variant="primary" onClick={this.handleQRList.bind(this)}>코드정보</Button>
                    {/* <Button variant="primary" onClick={this.handleRemove}>삭제</Button> */}
                </div>
                <div className="row" >
                    <Form>
                        {this.state.enable && <div style={{ margin: 20 }}>
                            <div className="col-md-6">
                                <Form.Row>
                                    <Form.Group as={Col} controlId="exampleForm.ControlInput1">
                                        <Form.Label>상품코드</Form.Label>
                                        <Form.Control type="title" placeholder="코드를 입력하세요." value={this.state.item.PCODE} onChange={this.handleChangePCODE.bind(this)} />
                                        <Button variant="primary" onClick={this.handleGetInfo.bind(this)}>S3에서 정보 가져오기</Button>
                                    </Form.Group>
                                    <Form.Group as={Col} controlId="exampleForm.ControlSelect1">
                                        <Form.Label>사용여부</Form.Label>
                                        <Form.Control as="select" value={this.state.item.USE_FLAG} onChange={this.handleChangeUSE.bind(this)}>
                                            <option>1</option>
                                            <option>0</option>
                                        </Form.Control>
                                    </Form.Group>
                                </Form.Row>

                                <Form.Group controlId="exampleForm.ControlInput1">
                                    <Form.Label>상품 이미지</Form.Label>
                                    <Form.Control type="title" placeholder="파일명 입력하세요." value={this.state.item.PIMAGE} onChange={this.handleChangePIMAGE.bind(this)} />
                                    <Form.Control as="select" value={this.state.item.PIMAGE} onChange={this.handleChangePIMAGE.bind(this)} onClick={this.handleChangePIMAGE.bind(this)}>
                                        {this.state.images.map((item, index) =>
                                            <option>{item.name}</option>
                                        )}
                                    </Form.Control>
                                </Form.Group>
                                <Form.Group controlId="exampleForm.ControlInput1">
                                    <Form.Label>미리보기</Form.Label>
                                    <Form.Control type="title" placeholder="파일명 입력하세요." value={this.state.item.PREVIEW} onChange={this.handleChangePREVIEW.bind(this)} />
                                    <Form.Control as="select" value={this.state.item.PREVIEW} onChange={this.handleChangePREVIEW.bind(this)} onClick={this.handleChangePREVIEW.bind(this)} >
                                        {this.state.vpreview.map((item, index) =>
                                            <option>{item.name}</option>
                                        )}
                                    </Form.Control>
                                </Form.Group>
                                <Form.Group controlId="exampleForm.ControlInput1">
                                    <Form.Label>자막 언어</Form.Label>
                                    <Form.Control type="title" placeholder="파일명 입력하세요." value={this.state.item.SUBLANGS} onChange={this.handleChangeLOCALS.bind(this)} />
                                </Form.Group>
                            </div>
                            <div className="col-md-6">
                                <Form.Group controlId="exampleForm.ControlInput1">
                                    <Form.Label>재생(분)</Form.Label>
                                    <Form.Control type="title" placeholder="파일명 입력하세요." value={this.state.item.PLAYTIME} onChange={this.handleChangePLAYTIME.bind(this)} />
                                </Form.Group>
                                <Form.Group controlId="exampleForm.ControlInput1">
                                    <Form.Label>파일크기(MB)</Form.Label>
                                    <Form.Control type="title" placeholder="파일크기 입력하세요." value={this.state.item.FILESIZE} onChange={this.handleChangeFILESIZE.bind(this)} />
                                </Form.Group>
                                <Form.Group controlId="exampleForm.ControlInput1">
                                    <Form.Label>영상품질(SD,HD)</Form.Label>
                                    <Form.Control type="title" placeholder="영상품질 입력하세요." value={this.state.item.QUALITY} onChange={this.handleChangeQUALITY.bind(this)} />
                                </Form.Group>
                                <Form.Group controlId="exampleForm.ControlInput1">
                                    <Form.Label>연령제한(0:제한없음,12:12세이상)</Form.Label>
                                    <Form.Control type="title" placeholder="연령제한 입력하세요." value={this.state.item.AGELIMIT} onChange={this.handleChangeAGELIMIT.bind(this)} />
                                </Form.Group>
                                <Form.Group controlId="exampleForm.ControlInput1">
                                    <Form.Label>좋아요</Form.Label>
                                    <Form.Control type="title" placeholder="연령제한 입력하세요." value={this.state.item.FAVORITES} onChange={this.handleChangeFAVORITES.bind(this)} />
                                </Form.Group>
                                <Form.Group as={Col} controlId="exampleForm.ControlSelect1">
                                    <Form.Label>검수중</Form.Label>
                                    <Form.Control as="select" value={this.state.item.REVIEW_FLAG} onChange={this.handleChangeREVIEW.bind(this)}>
                                        <option>1</option>
                                        <option>0</option>
                                    </Form.Control>
                                </Form.Group>
                                <Form.Group as={Col} controlId="exampleForm.ControlSelect1">
                                    <Form.Label>FreeContent</Form.Label>
                                    <Form.Control as="select" value={this.state.item.FREE_FLAG} onChange={this.freeContent.bind(this)}>
                                        <option>1</option>
                                        <option>0</option>
                                    </Form.Control>
                                </Form.Group>
                                <Form.Group controlId="exampleForm.ControlInput1">
                                    <Form.Label>구매 URL</Form.Label>
                                    <Form.Control type="title" placeholder="구매 URL이 있는 경우 입력하세요." value={this.state.item.BUY_URL} onChange={this.buyURL.bind(this)} />
                                </Form.Group>
                            </div>
                            <div className="col-md-6">
                                <Form.Group controlId="exampleForm.ControlTextarea1">
                                    <Form.Label>가격</Form.Label>
                                    <Form.Control as="textarea" rows="6" value={this.state.item.PRICE} onChange={this.handleChangePrice.bind(this)} />
                                </Form.Group>
                            </div>
                        </div>
                        }
                    </Form>
                </div>

                <div className="row">
                    <Modal visible={this.state.explanationvisible} width="500" effect="fadeInUp" onClickAway={this.handleCloseExplanation.bind(this)}>
                        <div style={{ margin: 20 }}>
                            <table>
                                <tr>
                                    <td>
                                        <div className="row" style={{ margin: 16 }}>
                                            <Button variant="primary" onClick={this.handleCloseExplanation.bind(this)}>X</Button>
                                        </div>
                                    </td>
                                    <td>
                                        <h2>사용설명</h2>
                                    </td>
                                </tr>
                            </table>
                            <DRMExplanation />
                        </div>
                    </Modal>
                </div>
                <div className="row">
                    <Modal visible={this.state.detailvisible} width="90%" effect="fadeInUp" onClickAway={this.handleCloseDetail.bind(this)}>
                        <div style={{ margin: 20 }}>
                            <table>
                                <tr>
                                    <td>
                                        <div className="row" style={{ margin: 16 }}>
                                            <Button variant="primary" onClick={this.handleCloseDetail.bind(this)}>X</Button>
                                        </div>
                                    </td>
                                    <td>
                                        <h2>상품 상세 내용 [{this.state.item.PCODE}]</h2>
                                    </td>
                                </tr>
                            </table>
                            <ProductDetail item={this.state.item} images={this.state.images} />
                        </div>
                    </Modal>
                </div>
                <div className="row">
                    <Modal visible={this.state.titlevisible} width="90%" effect="fadeInUp" onClickAway={this.handleCloseTitle.bind(this)}>
                        <div style={{ margin: 20 }}>
                            <table>
                                <tr>
                                    <td>
                                        <div className="row" style={{ margin: 16 }}>
                                            <Button variant="primary" onClick={this.handleCloseTitle.bind(this)}>X</Button>
                                        </div>
                                    </td>
                                    <td>
                                        <h2>타이틀 정보 [{this.state.item.PCODE}]</h2>
                                    </td>
                                </tr>
                            </table>
                            <ProductTitle item={this.state.item} images={this.state.images} />
                        </div>
                    </Modal>
                </div>
                <div className="row">
                    <Modal visible={this.state.photovisible} width="90%" effect="fadeInUp" onClickAway={this.handleClosePhoto.bind(this)}>
                        <div style={{ margin: 20 }}>
                            <table>
                                <tr>
                                    <td>
                                        <div className="row" style={{ margin: 16 }}>
                                            <Button variant="primary" onClick={this.handleClosePhoto.bind(this)}>X</Button>
                                        </div>
                                    </td>
                                    <td>
                                        <h2>사진 정보 [{this.state.item.PCODE}]</h2>
                                    </td>
                                </tr>
                            </table>
                            <ProductPhoto item={this.state.item} images={this.state.images} />
                        </div>
                    </Modal>
                </div>
                <div className="row">
                    <Modal visible={this.state.imageMapvisible} width="90%" effect="fadeInUp" onClickAway={this.handleCloseImageMap.bind(this)}>
                        <div style={{ margin: 20 }}>
                            <table>
                                <tr>
                                    <td>
                                        <div className="row" style={{ margin: 16 }}>
                                            <Button variant="primary" onClick={this.handleCloseImageMap.bind(this)}>X</Button>
                                        </div>
                                    </td>
                                    <td>
                                        <h2>이미지 맵 사진 정보 [{this.state.item.PCODE}]</h2>
                                    </td>
                                </tr>
                            </table>
                            <ProductImageMap item={this.state.item} images={this.state.images} />
                        </div>
                    </Modal>
                </div>
                <div className="row">
                    <Modal visible={this.state.qrlistvisible} width="90%" effect="fadeInUp" onClickAway={this.handleCloseQRList.bind(this)}>
                        <div style={{ margin: 20 }}>
                            <table>
                                <tr>
                                    <td>
                                        <div className="row" style={{ margin: 16 }}>
                                            <Button variant="primary" onClick={this.handleCloseQRList.bind(this)}>X</Button>
                                        </div>
                                    </td>
                                    <td>
                                        <h2>QR 및 코드 정보 [{this.state.item.PCODE}]</h2>
                                    </td>
                                </tr>
                            </table>
                            <ProductQRList item={this.state.item} images={this.state.images} />
                        </div>
                    </Modal>
                </div>


            </div>

        );
    }
};


export default class Product extends Component {
    static defaultProps = {
        onreset: () => { },
    }
    constructor(props) {
        super(props);
        this.state = {
            sendcount: 0,
            rowlist: [],
            productvisible: false,
            item: { ...ProductDefaults }
        };
    }

    handleRowClick = (event) => {
        var item = event.rowData;
        console.log(item);
        var edititem = { ...item };
        edititem.TITLE = item.TITLE;
        edititem.CONTENT = item.CONTENT;
        this.setState({ item: edititem });
        this.setState({ productvisible: true });

        // if(event =! null) event.preventDefault();
    }

    componentDidMount() {
        Config.fetchData('productsall', {
        }, (result, count) => {
            console.log('count=', count);
            this.setState({ rowlist: result })
        }, true);
    }

    handleReset(event) {
        this.setState({ item: { ...ProductDefaults } })
    }

    handleNew() {
        this.handleReset(null);
        this.setState({ productvisible: true });
    }

    handleClose = () => {
        console.log('handleClose');
        this.componentDidMount();
        this.setState({ productvisible: false });
    }

    handleScroll(scrollData) {
        console.log(scrollData);
    }

    _noRowsRenderer() {
        return <div>No rows</div>;
    }

    _onScrollToRowChange(event) {
        const { rowCount } = this.state;
        let scrollToIndex = Math.min(
            rowCount - 1,
            parseInt(event.target.value, 10),
        );

        if (isNaN(scrollToIndex)) {
            scrollToIndex = undefined;
        }

        this.setState({ scrollToIndex });
    }

    _rowClassName({ index }) {
        if (index < 0) {
            return "headerRow";
        } else {
            return index % 2 === 0 ? "evenRow" : "oddRow";
        }
    }

    render() {
        let scrollbarStyles = { borderRadius: 5 };
        return (
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="box">
                                <div className="box-header with-border">
                                    <table>
                                        <tr>
                                            <td>
                                                <h3 className="box-title">상품 등록</h3>
                                            </td>
                                            <td>
                                                <div className="row" style={{ margin: 16 }}>
                                                    <Button variant="primary" onClick={this.handleNew.bind(this)}>신규</Button>
                                                </div>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div className="box-body" style={{ margin: 20 }}>
                                    <div className="row" >
                                        <AutoSizer disableHeight>
                                            {({ width }) => (
                                                <Table
                                                    ref="Table"
                                                    headerClassName={'headerColumn'}
                                                    onRowClick={this.handleRowClick}
                                                    headerHeight={30}
                                                    height={800}
                                                    noRowsRenderer={this._noRowsRenderer}
                                                    overscanRowCount={10}
                                                    rowClassName={this._rowClassName}
                                                    rowHeight={40}
                                                    rowGetter={({ index }) => this.state.rowlist[index]}
                                                    rowCount={this.state.rowlist.length}
                                                    scrollToIndex={this.state.scrollToIndex}
                                                    width={width}>
                                                    <Column
                                                        width={70}
                                                        disableSort
                                                        label="코드"
                                                        dataKey="PCODE"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        style={{ minWidth: 40 }}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={50}
                                                        disableSort
                                                        label="사용"
                                                        dataKey="USE_FLAG"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={50}
                                                        disableSort
                                                        label="검수"
                                                        dataKey="REVIEW_FLAG"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={50}
                                                        disableSort
                                                        label="무료"
                                                        dataKey="FREE_FLAG"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={250}
                                                        disableSort
                                                        label="상품 타이틀"
                                                        dataKey="TITLE"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={200}
                                                        disableSort
                                                        label="상품 이미지"
                                                        dataKey="PIMAGE"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={200}
                                                        disableSort
                                                        label="자막 언어"
                                                        dataKey="SUBLANGS"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={90}
                                                        disableSort
                                                        label="재생(분)"
                                                        dataKey="PLAYTIME"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={200}
                                                        disableSort
                                                        label="미리보기"
                                                        dataKey="PREVIEW"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={90}
                                                        disableSort
                                                        label="파일크기"
                                                        dataKey="FILESIZE"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={50}
                                                        disableSort
                                                        label="품질"
                                                        dataKey="QUALITY"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={50}
                                                        disableSort
                                                        label="연령"
                                                        dataKey="AGELIMIT"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={50}
                                                        disableSort
                                                        label="좋아요"
                                                        dataKey="FAVORITES"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                    <Column
                                                        width={200}
                                                        disableSort
                                                        label="등록일"
                                                        dataKey="REGDATE"
                                                        className={'exampleColumn'}
                                                        cellRenderer={({ cellData }) => cellData}
                                                        flexGrow={1}
                                                    />
                                                </Table>
                                            )}
                                        </AutoSizer>
                                    </div>
                                    <div className="row">
                                        <Modal visible={this.state.productvisible} width="95%" effect="fadeInUp" onreset={() => { this.componentDidMount() }} onClickAway={() => this.handleClose()}>
                                            <div style={{ margin: 20 }}>
                                                <table>
                                                    <tr>
                                                        <td>
                                                            <div className="row" style={{ margin: 16 }}>
                                                                <Button variant="primary" onClick={this.handleClose.bind(this)}>X</Button>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <h2>상품내용</h2>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <Content item={this.state.item} enable={this.state.productvisible} onreset={() => { this.componentDidMount() }} />
                                            </div>
                                        </Modal>
                                    </div>
                                </div>
                                <div className="box-footer">
                                    <div className="row">
                                        <div className="col-sm-3 col-xs-6">
                                            <div className="description-block border-right">
                                                {/* <span className="description-percentage text-green"><i className="fa fa-caret-up"></i> 17%</span> */}
                                                {/* <h5 className="description-header">Sending TOTAL: {this.state.sendcount}</h5> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// src/components/Product.js